"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles2 = require("../utilities/styles");
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
var _keys = _interopRequireDefault(require("../poly/keys"));
const _excluded = ["hover", "focus"],
  _excluded2 = ["children", "classes", "color", "variant", "onClick", "telemetryName", "href", "fullHeight", "disabled", "disableWipe", "textDecorationStyle"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const getBaseStyles = (baseStyles, breakpoints) => {
  return (0, _extends2.default)({}, baseStyles.mobile, {
    [breakpoints.up('md')]: (0, _extends2.default)({}, baseStyles.desktop)
  });
};
const getStyles = (variant, palette, breakpoints) => (0, _keys.default)(palette.button[variant]).reduce((styles, key) => {
  if (key === "base") {
    return (0, _extends2.default)({}, styles, {
      [(0, _camelCase.default)([variant, 'base'])]: getBaseStyles(palette.button[variant]['base'], breakpoints)
    });
  }
  const color = key;
  const _palette$button$varia = palette.button[variant][color],
    {
      hover,
      focus
    } = _palette$button$varia,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_palette$button$varia, _excluded);
  const hoverStyle = (0, _extends2.default)({}, hover, {
    fill: hover.color
  });
  const focusStyle = (0, _extends2.default)({}, focus, {
    fill: focus.color
  });
  return (0, _extends2.default)({}, styles, {
    [(0, _camelCase.default)([variant, color])]: (0, _extends2.default)({}, rest, {
      fill: rest.color
    }),
    [(0, _camelCase.default)([variant, color, 'hover'])]: {
      '&:hover': hoverStyle
    },
    [(0, _camelCase.default)([variant, color, 'focus'])]: {
      '&:focus': focusStyle
    }
  });
}, {});
const buildTextStyles = (palette, breakpoints) => (0, _extends2.default)({
  text: {
    display: 'inline',
    minHeight: 'initial',
    minWidth: 'initial',
    letterSpacing: '0.1px',
    textAlign: 'left',
    padding: 0,
    color: palette.text.primary,
    fill: palette.text.primary,
    '&:focus,&:hover': {
      color: palette.primary.main,
      textDecoration: ({
        textDecorationStyle
      }) => `${textDecorationStyle}`,
      background: 'none'
    }
  },
  textFocus: {
    color: palette.primary.main,
    fill: palette.primary.main,
    textDecoration: ({
      textDecorationStyle
    }) => `${textDecorationStyle}`
  }
}, getStyles('text', palette, breakpoints));
const buildContainedStyles = (palette, breakpoints) => (0, _extends2.default)({
  contained: {
    borderWidth: '2px',
    borderStyle: 'solid',
    color: palette.button.contained.primary.color,
    fill: palette.button.contained.primary.color,
    background: palette.button.contained.primary.background,
    borderColor: palette.button.contained.primary.border,
    '&$disabled': {
      color: palette.button.contained.primary.color
    }
  },
  containedFocus: {
    color: palette.button.contained.primary.focus.color,
    background: palette.button.contained.primary.focus.background,
    borderColor: palette.button.contained.primary.focus.border
  }
}, getStyles('contained', palette, breakpoints));
const buildOutlineStyles = (palette, breakpoints) => (0, _extends2.default)({
  outline: {
    borderWidth: '2px',
    borderStyle: 'solid',
    color: palette.button.outline.primary.color,
    fill: palette.button.outline.primary.color,
    background: palette.button.outline.primary.background,
    borderColor: palette.button.outline.primary.border
  },
  outlineFocus: {
    color: palette.button.outline.primary.hover.color,
    fill: palette.button.outline.primary.hover.color,
    background: palette.button.outline.primary.hover.background,
    borderColor: palette.button.outline.primary.hover.border
  }
}, getStyles('outline', palette, breakpoints));
const useClasses = (0, _styles.makeStyles)(({
  palette,
  breakpoints,
  accessibility: {
    highContrast
  }
}) => (0, _extends2.default)({
  buttonBase: (0, _extends2.default)({
    userSelect: 'auto',
    padding: '0.5em 1.5em',
    textAlign: 'center',
    minHeight: '40px',
    '&:hover, &:focus': {
      textDecoration: 'none'
    },
    [breakpoints.up('md')]: {
      minHeight: '50px'
    },
    [breakpoints.down('sm')]: {
      width: '100%'
    }
  }, palette.button.buttonBase),
  focusVisible: {
    outline: `3px solid ${palette.text.primary}`,
    boxShadow: `0 0 0 6px ${palette.site.background}`
  },
  fullHeight: {
    height: '100%'
  },
  labelBase: (0, _extends2.default)({
    transform: 'translateY(1px)'
  }, palette.button.labelBase),
  disabled: {
    opacity: .6
  },
  iconButton: {
    display: 'flex',
    flexDirection: 'row'
  },
  highContrastLink: {
    [highContrast.mediaQuery('active')]: {
      color: 'LinkText !important',
      '&:focus,&:hover': {
        color: 'WindowText !important'
      }
    }
  }
}, buildTextStyles(palette, breakpoints, highContrast), buildContainedStyles(palette, breakpoints), buildOutlineStyles(palette, breakpoints)), {
  classNamePrefix: 'TCUIButton'
});
const wipeStyles = (0, _styles.makeStyles)(({
  palette,
  transitions
}) => ({
  root: {
    zIndex: 0,
    '&::after': {
      content: '" "',
      position: 'absolute',
      width: '100%',
      height: '100%',
      transform: 'scaleX(0)',
      top: 0,
      left: 0,
      zIndex: -1,
      transformOrigin: 'center',
      transition: `transform 300ms ${transitions.easing.easeInOut}, outline 300ms ${transitions.easing.easeInOut}`
    },
    '&:hover': {
      '&::after': {
        transform: 'scaleX(1)',
        zIndex: -1
      }
    }
  },
  /**
   * CONTAINED CLASSES
   */
  containedHover: {
    '&::after': {
      background: palette.button.contained.primary.hover.background,
      outline: `2px solid ${palette.button.contained.primary.hover.background}`
    },
    '&:hover': {
      background: palette.button.contained.primary.background,
      '&::after': {
        outline: `2px solid ${palette.button.contained.primary.hover.border}`
      }
    }
  },
  containedPrimaryHover: {
    '&::after': {
      background: palette.button.contained.primary.hover.background,
      outline: `2px solid ${palette.button.contained.primary.hover.background}`
    },
    '&:hover': {
      background: palette.button.contained.primary.background,
      '&::after': {
        outline: `2px solid ${palette.button.contained.primary.hover.border}`
      }
    }
  },
  containedSecondaryHover: {
    '&::after': {
      background: palette.button.contained.secondary.hover.background,
      outline: 'none'
    },
    '&:hover': {
      background: palette.button.contained.secondary.background,
      '&::after': {
        outline: 'none'
      }
    }
  },
  containedTertiaryHover: {
    '&::after': {
      background: palette.button.contained.tertiary.hover.background,
      outline: 'none'
    },
    '&:hover': {
      background: palette.button.contained.tertiary.background,
      '&::after': {
        outline: 'none'
      }
    }
  },
  containedQuaternaryHover: {
    '&::after': {
      background: palette.button.contained.quaternary.hover.background,
      outline: `2px solid ${palette.button.contained.quaternary.hover.background}`
    },
    '&:hover': {
      background: palette.button.contained.quaternary.background,
      '&::after': {
        outline: `2px solid ${palette.button.contained.quaternary.hover.border}`
      }
    }
  }
}), {
  classNamePrefix: 'TCUIButtonWipe'
});
const setAnalytics = (e, telemetryName, url, callback) => {
  if (!!telemetryName && !!window.appInsights) {
    window.appInsights.trackEvent({
      name: 'Button Click',
      properties: {
        title: telemetryName,
        url: url
      }
    });
  }
  if (callback) {
    callback(e);
  }
};
const Button = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      // component,
      children,
      classes,
      color,
      variant,
      onClick,
      telemetryName,
      href,
      fullHeight,
      disabled,
      disableWipe,
      textDecorationStyle
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded2);
  // const _classes = useClasses({ scrollColor })
  const _classes = useClasses({
    textDecorationStyle
  });
  const _wipeAnimation = wipeStyles();
  const handleOnClick = e => setAnalytics(e, telemetryName, href, onClick);
  const theme = (0, _styles.useTheme)();
  const buttonClasses = {
    root: (0, _clsx.default)(_classes.buttonBase, _classes[variant], _classes[(0, _camelCase.default)([variant, 'base'])], disableWipe || variant !== 'contained' ? (0, _clsx.default)(_classes[(0, _camelCase.default)([variant, 'hover'])], {
      [_classes[(0, _camelCase.default)([variant, color, 'hover'])]]: !!variant && !!color
    }) : (0, _clsx.default)(_wipeAnimation.root, _wipeAnimation[(0, _camelCase.default)([variant, 'hover'])], _wipeAnimation[(0, _camelCase.default)([variant, color, 'hover'])]), {
      [_classes[(0, _camelCase.default)([variant, color])]]: !!variant && !!color,
      [_classes.fullHeight]: fullHeight,
      [_classes.highContrastLink]: variant === 'text' && !!href
    }),
    focusVisible: (0, _clsx.default)(_classes.focusVisible, {
      [_classes[(0, _camelCase.default)([variant, 'focus'])]]: !!variant && !color,
      [_classes[(0, _camelCase.default)([variant, color, 'focus'])]]: !!variant && !!color
    }),
    label: (0, _clsx.default)({
      [_classes.labelBase]: variant !== 'text'
    }),
    disabled: _classes.disabled
  };

  // const _Component = component ? component : (href ? 'a' : 'button')

  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, rest, {
    onClick: handleOnClick,
    href: href,
    ref: ref,
    classes: (0, _styles2.mergeClasses)(buttonClasses, classes),
    disabled: disabled
  }), children);
});
Button.propTypes = {
  color: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  children: _propTypes.default.node,
  classes: _propTypes.default.object,
  variant: _propTypes.default.oneOf(['text', 'contained', 'outline']),
  onClick: _propTypes.default.func,
  fullHeight: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  disableWipe: _propTypes.default.bool,
  // Currently only for contained button types
  telemetryName: _propTypes.default.string,
  href: _propTypes.default.string
};
Button.defaultProps = {
  color: null,
  variant: 'text',
  children: null,
  classes: {},
  onClick: null,
  fullHeight: false,
  disabled: false,
  disableWipe: true,
  // Currently only for contained button types
  telemetryName: null,
  href: null,
  textDecorationStyle: 'underline'
};
var _default = exports.default = Button;